module.exports = __webpack_public_path__ + "static/img/ecotemp1-icon.c70af3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/refs/eco/ecotemp1-icon.jpg
// module id = 7E0J
// module chunks = 0